
import {
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Button,
  Select,
  Option,
  Upload,
  Input,
  InputNumber,
  RadioGroup,
  Radio,
} from 'element-ui';
import { IQuestion, IEditques } from '@/types/question.d';
import api from '@/api/question';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Button,
    Select,
    Option,
    Upload,
    Input,
    InputNumber,
    RadioGroup,
    Radio,
  },
})
export default class EditModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '编辑',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: IEditques;

  private fileList: { url?: string }[] = [];

  private multiple: boolean = false;

  private show: boolean = false;

  private types: { value: number; label: string; }[] = [
    { value: 0, label: '单选题' },
    { value: 1, label: '多选题' },
  ];

  get answers() {
    const answers:object[] = [];
    let i = 1;
    while (i <= this.form.options) {
      answers.push({ value: i.toString(), label: String.fromCharCode(i + 64) });
      i += 1;
    }
    return answers;
  }

  mounted() {
    if (this.oldForm && this.oldForm.id) {
      api.checkQues(this.oldForm.id).then((res: any) => {
        if (res.status) {
          this.show = !res.data;
        }
      });
    }
    this.form = Object.assign({}, this.oldForm);
    this.fileList = [{ url: this.form.context }];
    if (this.form.qstType === '3') {
      this.multiple = false;
    } else this.multiple = true;
  }

  /**
   * @author liangyongmou
   * @desc 点击单选多选项
   * @param { string } v 当前选中值
   */
  handleRadioClick(v: string) {
    if (v === '4') this.multiple = true;
    else this.multiple = false;
    this.form.answer = [];
  }

  /**
   * @author liangyongmou
   * @desc 选项数改变事件
   */
  handleChangeOptions() {
    this.form.answer = '';
  }

  /**
   * @author liangyongmou
   * @desc 题目上传前事件
   */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileList = [{ url: e.target.result }];
    };
    this.form.file = file;
    return false;
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    this.resetForm();
    if (close) this.$emit('update:visible', false);
    else this.fileList = [{ url: this.oldForm.context }];
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
  }
}
